import { render, staticRenderFns } from "./mahjongXmas.vue?vue&type=template&id=17f23708"
import script from "./mahjongXmas.vue?vue&type=script&lang=js"
export * from "./mahjongXmas.vue?vue&type=script&lang=js"
import style0 from "./mahjongXmas.vue?vue&type=style&index=0&id=17f23708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports